import {
  ANOMALIES_LIST_SET,
  ANOMALIES_LIST_REQ,
  ANOMALIES_LIST_SUCCESS,
  ANOMALIES_LIST_ERROR,
  ANOMALIES_SUMMARY_SET,
  ANOMALIES_SUMMARY_REQ,
  ANOMALIES_SUMMARY_SUCCESS,
  ANOMALIES_SUMMARY_ERROR,
  ANOMALIES_DETAILS_REQ,
  ANOMALIES_DETAILS_SUCCESS,
  ANOMALIES_DETAILS_ERROR,
  DISMISS_ANOMALIES_REQ,
  DISMISS_ANOMALIES_SUCCESS,
  DISMISS_ANOMALIES_ERROR,
  ENABLE_ANOMALY_RULE_REQ,
  ENABLE_ANOMALY_RULE_SUCCESS,
  ENABLE_ANOMALY_RULE_ERROR,
  ANOMALIES_VIEW_PREFERENCES_REQ,
  SAVE_ANOMALIES_VIEW_PREFERENCES,
  ANOMALIES_RULE_VIEW_PREFERENCES_REQ,
  SAVE_ANOMALIES_RULE_VIEW_PREFERENCES
} from './anomalies.type'

import { anomaliesMetaInfo } from '@/column-header/anomalies/anomalies-meta'
import { anomalyRulesMetaInfo } from '@/column-header/anomalies/anomaly-rules-meta'
import IQCollection from '@/resources/collections/IQCollection'
import ExcessAnomalies from '@/resources/models/anomalies/ExcessAnomalies'
import NewAnomalies from '@/resources/models/anomalies/NewAnomalies'
import ProcessAnomalies from '@/resources/models/anomalies/ProcessAnomalies'
import ApiRest from '@/api/api-rest'
import { OrderByEnum } from '@/constants/orderby.constants'
import { interpolateText } from '@/utilities/string.helper'
import { getDateRangeChoice } from '@/utilities/datetime.helper'

const state = {
  anomalySummaryReqStatus: '',
  anomalySummary: {
    anomalyCategoryCount: {},
    anomalyTypeSummary: {},
    stateCount: {},
    anomalyDetectorSummaryList: {},
    anomalyRules: []
  },
  anomaliesReqStatus: '',
  anomalies: {},
  anomalyDetailsReqStatus: '',
  dismissAnomalyDetailsReqStatus: '',
  enableAnomalyDetailsReqStatus: '',
  anomaliesPreferences: [],
  anomaliesRulePreferences: []
}

const getters = {
  anomalySummaryReqStatus: state => state.anomalySummaryReqStatus,
  anomalySummary: state => state.anomalySummary,
  anomaliesReqStatus: state => state.anomaliesReqStatus,
  anomalies: state => state.anomalies,
  anomalyDetailsReqStatus: state => state.anomalyDetailsReqStatus,
  dismissAnomalyDetailsReqStatus: state => state.dismissAnomalyDetailsReqStatus,
  enableAnomalyDetailsReqStatus: state => state.enableAnomalyDetailsReqStatus,
  anomaliesPreferences: state => state.anomaliesPreferences,
  anomaliesRulePreferences: state => state.anomaliesRulePreferences
}

// Best Practice - updates state
const mutations = {
  [ANOMALIES_LIST_SET]: (state, data) => {
    state.anomalies = data
  },
  [ANOMALIES_LIST_REQ]: state => {
    state.anomaliesReqStatus = 'loading'
  },
  [ANOMALIES_LIST_SUCCESS]: (state, data) => {
    state.anomaliesReqStatus = 'saved'
  },
  [ANOMALIES_LIST_ERROR]: (state, errMsg) => {
    state.anomaliesReqStatus = 'error'
  },
  [ANOMALIES_SUMMARY_SET]: (state, data) => {
    state.anomalySummary = data
    let rules = _.map(data.anomalyDetectorSummaryList, rule => {
      let anomalyRule = _.merge(rule, rule.anomalyDetector)
      return anomalyRule
    })
    let anomalyRules = new IQCollection(rules, { attributes: anomalyRulesMetaInfo.meta.columns }, {})
    state.anomalySummary.anomalyRules = anomalyRules
  },
  [ANOMALIES_SUMMARY_REQ]: state => {
    state.anomalySummaryReqStatus = 'loading'
  },
  [ANOMALIES_SUMMARY_SUCCESS]: (state, data) => {
    state.anomalySummaryReqStatus = 'saved'
  },
  [ANOMALIES_SUMMARY_ERROR]: (state, errMsg) => {
    state.anomalySummaryReqStatus = 'error'
  },
  [ANOMALIES_DETAILS_REQ]: state => {
    state.anomalyDetailsReqStatus = 'loading'
  },
  [ANOMALIES_DETAILS_SUCCESS]: (state, data) => {
    state.anomalyDetailsReqStatus = 'saved'
  },
  [ANOMALIES_DETAILS_ERROR]: (state, errMsg) => {
    state.anomalyDetailsReqStatus = 'error'
  },
  [DISMISS_ANOMALIES_REQ]: (state, errMsg) => {
    state.dismissAnomalyDetailsReqStatus = 'error'
  },
  [DISMISS_ANOMALIES_SUCCESS]: (state, uid) => {
    let dismissed = _.find(state.anomalies.models, { uid: uid })
    if (dismissed) {
      dismissed.state = 'INACTIVE'
    }
    state.dismissAnomalyDetailsReqStatus = 'saved'
  },
  [DISMISS_ANOMALIES_ERROR]: (state, errMsg) => {
    state.dismissAnomalyDetailsReqStatus = 'error'
  },
  [ENABLE_ANOMALY_RULE_REQ]: (state, errMsg) => {
    state.enableAnomalyDetailsReqStatus = 'error'
  },
  [ENABLE_ANOMALY_RULE_SUCCESS]: (state, data) => {
    state.enableAnomalyDetailsReqStatus = 'saved'
  },
  [ENABLE_ANOMALY_RULE_ERROR]: (state, errMsg) => {
    state.enableAnomalyDetailsReqStatus = 'error'
  },
  [ANOMALIES_VIEW_PREFERENCES_REQ]: (state, data) => {
    state.anomaliesPreferences = data
  },
  [ANOMALIES_RULE_VIEW_PREFERENCES_REQ]: (state, data) => {
    state.anomaliesRulePreferences = data
  }
}

// Best Practice - actions call mutations
// make api call and commit states
const actions = {
  [ANOMALIES_VIEW_PREFERENCES_REQ] (context, uid) {
    return new Promise((resolve, reject) => {
      ApiRest()
        .get('preferences')
        .then(({ data }) => {
          let currUserAnomaliesPrefs = data.find(pref => {
            return pref.tbl_id === 7 && pref.user_id === uid
          })
          context.commit(ANOMALIES_VIEW_PREFERENCES_REQ, currUserAnomaliesPrefs.prefered_cols)
          resolve(data)
        })
    })
  },
  [SAVE_ANOMALIES_VIEW_PREFERENCES] (context, payload) {
    return new Promise((resolve, reject) => {
      ApiRest()
        .post('preferences', {
          userId: payload.userId,
          tblId: payload.tblId,
          preferedCols: payload.preferedCols
        })
        .then(resp => {
          resolve(resp)
        })
        .catch(errMsg => {
          reject(errMsg)
        })
    })
  },
  [ANOMALIES_RULE_VIEW_PREFERENCES_REQ] (context, uid) {
    return new Promise((resolve, reject) => {
      ApiRest()
        .get('preferences')
        .then(({ data }) => {
          let currUserAnomaliesRulePrefs = data.find(pref => {
            return pref.tbl_id === 8 && pref.user_id === uid
          })
          context.commit(ANOMALIES_RULE_VIEW_PREFERENCES_REQ, currUserAnomaliesRulePrefs.prefered_cols)
          resolve(data)
        })
    })
  },
  [SAVE_ANOMALIES_RULE_VIEW_PREFERENCES] (context, payload) {
    return new Promise((resolve, reject) => {
      ApiRest()
        .post('preferences', {
          userId: payload.userId,
          tblId: payload.tblId,
          preferedCols: payload.preferedCols
        })
        .then(resp => {
          resolve(resp)
        })
        .catch(errMsg => {
          reject(errMsg)
        })
    })
  },
  [ANOMALIES_LIST_REQ] (context, { dateRangeSel } = {}) {
    let lastXHours = ''
    if (dateRangeSel) {
      lastXHours = getDateRangeChoice(dateRangeSel)
    } else {
      lastXHours = getDateRangeChoice(context.rootState.daterangePref.anomaliesDateRangeUserSetting)
    }
    let detectionsUrl = `/anomaly/detections/${lastXHours.value}`
    return new Promise((resolve, reject) => {
      context.commit(ANOMALIES_LIST_REQ)
      ApiRest()
        .get(detectionsUrl)
        .then(({ data }) => {
          data = _.map(data, anomaly => {
            anomaly.host = { customHostname: anomaly.agentId }
            if (!_.isEmpty(context.rootState.agents.agentList.models)) {
              let hostfound = _.find(context.rootState.agents.agentList.models, {
                agentNumber: anomaly.agentId
              })
              if (hostfound) {
                anomaly.host = hostfound
              }
            }
            anomaly.description = interpolateText(anomaly.description, {
              host: anomaly.host.customHostname || '',
              ip: anomaly.ip || '',
              user: anomaly.user || '',
              city: anomaly.city || '',
              country: anomaly.country || ''
            })
            if (_.keys(anomaly.entities).includes('agentId') || _.keys(anomaly.entities).includes('host')) {
              anomaly.entities.agentId = anomaly.host.agentId || anomaly.agentId
              anomaly.entities.host = anomaly.host.customHostname || ''
            }
            return anomaly
          })
          let anomalies = new IQCollection(
            data,
            { attributes: anomaliesMetaInfo.meta.columns },
            { defaultSort: 'eventTime', sortOrder: OrderByEnum.ASC }
          )
          context.commit(ANOMALIES_LIST_SET, anomalies)
          resolve(anomalies)
        })
        .catch(errMsg => {
          context.commit(ANOMALIES_LIST_ERROR, errMsg)
          reject(errMsg)
        })
    })
  },
  [ANOMALIES_LIST_SUCCESS] (context) {
    context.commit(ANOMALIES_LIST_SUCCESS)
  },
  [ANOMALIES_SUMMARY_REQ] (context, { dateRangeSel } = {}) {
    let lastXHours = ''
    if (dateRangeSel) {
      lastXHours = getDateRangeChoice(dateRangeSel)
    } else {
      lastXHours = getDateRangeChoice(context.rootState.daterangePref.anomaliesDateRangeUserSetting)
    }
    let summaryUrl = `/anomaly/summary/${lastXHours.value}`
    return new Promise((resolve, reject) => {
      ApiRest()
        .get(summaryUrl)
        .then(({ data }) => {
          context.commit(ANOMALIES_SUMMARY_SET, data)
          resolve(data)
        })
        .catch(errMsg => {
          context.commit(ANOMALIES_SUMMARY_ERROR, errMsg)
          reject(errMsg)
        })
    })
  },
  [ANOMALIES_DETAILS_REQ] (context, { uid, type }) {
    let anomalyIdEncoded = encodeURIComponent(uid)
    return new Promise((resolve, reject) => {
      context.commit(ANOMALIES_DETAILS_REQ)
      ApiRest()
        .get(`/anomaly/detections?detection_id=${anomalyIdEncoded}`)
        .then(({ data }) => {
          if (type.toLowerCase() === 'new_login') {
            resolve(
              new NewAnomalies('', data.drillDownResult, {
                hosts: !_.isEmpty(context.rootState.agents.agentList.models)
                  ? context.rootState.agents.agentList.models
                  : []
              })
            )
          } else if (type.toLowerCase() === 'excess_login') {
            resolve(
              new ExcessAnomalies('', data.drillDownResult, {
                hosts: !_.isEmpty(context.rootState.agents.agentList.models)
                  ? context.rootState.agents.agentList.models
                  : []
              })
            )
          } else if (type.toLowerCase() === 'process') {
            resolve(
              new ProcessAnomalies('', data.drillDownResult, {
                hosts: !_.isEmpty(context.rootState.agents.agentList.models)
                  ? context.rootState.agents.agentList.models
                  : []
              })
            )
          }
          context.commit(ANOMALIES_DETAILS_SUCCESS)
        })
        .catch(errMsg => {
          context.commit(ANOMALIES_DETAILS_ERROR, errMsg)
          reject(errMsg)
        })
    })
  },
  [DISMISS_ANOMALIES_REQ] (context, { uid, type }) {
    let anomalyIdEncoded = encodeURIComponent(uid)
    return new Promise((resolve, reject) => {
      context.commit(DISMISS_ANOMALIES_REQ)
      ApiRest()
        .post(`/anomaly/detections/dismiss/${anomalyIdEncoded}`)
        .then(({ data }) => {
          resolve(data)
          context.commit(DISMISS_ANOMALIES_SUCCESS, uid)
        })
        .catch(errMsg => {
          context.commit(DISMISS_ANOMALIES_ERROR, errMsg)
          reject(errMsg)
        })
    })
  },
  [ENABLE_ANOMALY_RULE_REQ] (context, { ruleId, enable }) {
    return new Promise((resolve, reject) => {
      context.commit(ENABLE_ANOMALY_RULE_REQ)
      ApiRest()
        .post(`/anomaly/rule/${ruleId}`, {
          state: enable
        })
        .then(({ data }) => {
          resolve(data)
          context.commit(ENABLE_ANOMALY_RULE_SUCCESS)
        })
        .catch(errMsg => {
          context.commit(ENABLE_ANOMALY_RULE_ERROR, errMsg)
          reject(errMsg)
        })
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/anomalies/anomalies.module.js